import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Team1 from '../components/team1'
import FooterMain from '../components/footer-main'
import './team.css'

const Team = (props) => {
  return (
    <div className="team-container">
      <Helmet>
        <title>
          Команда инженеров Arcobo | Эксперты по промышленной роботизации
        </title>
        <meta
          name="description"
          content="Инженеры Arcobo с опытом внедрения промышленных роботов, WAAM-систем и автоматизации производства. Экспертиза в Казахстане и Центральной Азии."
        />
        <meta
          property="og:title"
          content="Команда инженеров Arcobo | Эксперты по промышленной роботизации"
        />
        <meta
          property="og:description"
          content="Инженеры Arcobo с опытом внедрения промышленных роботов, WAAM-систем и автоматизации производства. Экспертиза в Казахстане и Центральной Азии."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Команда инженеров Arcobo | Эксперты по промышленной роботизации"
        />
        <meta
          name="twitter:description"
          content="Инженеры Arcobo с опытом внедрения промышленных роботов, WAAM-систем и автоматизации производства. Экспертиза в Казахстане и Центральной Азии."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/team"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/team"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Team","item":"https://arcobo.tech/team"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name3"></HeaderMain>
      <hr className="team-separator1"></hr>
      <Team1
        titleAs="h1"
        member1={
          <Fragment>
            <span className="team-text10">Full name</span>
          </Fragment>
        }
        member2={
          <Fragment>
            <span className="team-text11">Full name</span>
          </Fragment>
        }
        member3={
          <Fragment>
            <span className="team-text12">Full name</span>
          </Fragment>
        }
        member4={
          <Fragment>
            <span className="team-text13">Full name</span>
          </Fragment>
        }
        member5={
          <Fragment>
            <span className="team-text14">Full name</span>
          </Fragment>
        }
        member6={
          <Fragment>
            <span className="team-text15">Full name</span>
          </Fragment>
        }
        content2={
          <Fragment>
            <span className="team-text16">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              <span
                dangerouslySetInnerHTML={{
                  __html: ' ',
                }}
              />
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="team-text17">Our team</span>
          </Fragment>
        }
        member1Job={
          <Fragment>
            <span className="team-text18">Job title</span>
          </Fragment>
        }
        member2Job={
          <Fragment>
            <span className="team-text19">Job title</span>
          </Fragment>
        }
        member3Job={
          <Fragment>
            <span className="team-text20">Job title</span>
          </Fragment>
        }
        member4Job={
          <Fragment>
            <span className="team-text21">Job title</span>
          </Fragment>
        }
        member5Job={
          <Fragment>
            <span className="team-text22">Job title</span>
          </Fragment>
        }
        member6Job={
          <Fragment>
            <span className="team-text23">Job title</span>
          </Fragment>
        }
        member1Content={
          <Fragment>
            <span className="team-text24">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse varius enim in eros elementum tristique.
            </span>
          </Fragment>
        }
        member2Content={
          <Fragment>
            <span className="team-text25">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse varius enim in eros elementum tristique.
            </span>
          </Fragment>
        }
        member3Content={
          <Fragment>
            <span className="team-text26">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse varius enim in eros elementum tristique.
            </span>
          </Fragment>
        }
        member4Content={
          <Fragment>
            <span className="team-text27">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse varius enim in eros elementum tristique.
            </span>
          </Fragment>
        }
        member5Content={
          <Fragment>
            <span className="team-text28">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse varius enim in eros elementum tristique.
            </span>
          </Fragment>
        }
        member6Content={
          <Fragment>
            <span className="team-text29">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse varius enim in eros elementum tristique.
            </span>
          </Fragment>
        }
      ></Team1>
      <hr className="team-separator2"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name3"></FooterMain>
    </div>
  )
}

export default Team
